export type PermissionValues =
    'users.view' | 'users.manage' |
    'roles.view' | 'roles.manage' | 'roles.assign' |
    'reports.view' | 'reports.change' | 'reports.delete' | 'reports.reactivate' |
    'organizations.view' | 'organizations.change' | 'organizations.delete' | 
    'businesses.view' | 'businesses.change' | 'businesses.delete' | 
    'referenceData.view' | 'referenceData.change' | 'referenceData.delete' | 
    'modelData.manage';

export class Permission {

    public static readonly viewUsersPermission: PermissionValues = "users.view";
    public static readonly manageUsersPermission: PermissionValues = "users.manage";

    public static readonly viewRolesPermission: PermissionValues = "roles.view";
    public static readonly manageRolesPermission: PermissionValues = "roles.manage";
    public static readonly assignRolesPermission: PermissionValues = "roles.assign";

    public static readonly viewReports: PermissionValues = "reports.view";
    public static readonly changeReports: PermissionValues = "reports.change";
    public static readonly deleteReports: PermissionValues = "reports.delete";
    public static readonly reactivateReports: PermissionValues = "reports.reactivate";

    public static readonly viewOrganizations: PermissionValues = "organizations.view";
    public static readonly changeOrganizations: PermissionValues = "organizations.change";
    public static readonly deleteOrganizations: PermissionValues = "organizations.delete";

    public static readonly viewBusinesses: PermissionValues = "businesses.view";
    public static readonly changeBusinesses: PermissionValues = "businesses.change";
    public static readonly deleteBusinesses: PermissionValues = "businesses.delete";

    public static readonly viewReferenceData: PermissionValues = "referenceData.view";
    public static readonly changeReferenceData: PermissionValues = "referenceData.change";
    public static readonly deleteReferenceData: PermissionValues = "referenceData.delete";

    public static readonly manageModel: PermissionValues = "modelData.manage";

    constructor(name?: string, value?: string, groupName?: string, description?: string) {
        this.name = name;
        this.value = value;
        this.groupName = groupName;
        this.description = description;
    }

    public name: string;
    public value: string;
    public groupName: string;
    public description: string;
}
